const state = {
    workorderHistoryWireUseInformationFields: [
        {
            key: "index",
            label: "項次",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "code",
            label: "線材品號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "chinese_name",
            label: "線材品名",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "scroll_no",
            label: "線材捲號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "furnaceCode",
            label: "爐號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "consumption",
            label: "耗用量(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        // {
        //     key: "attrition",
        //     label: "超耗率(%)",
        //     sortable: false,
        //     class: "font-family-dfyuanstd-w5 table-col-hight"
        // }
    ],
    workorderHistoryWireUseInformationItem: [],
}
const getters = {
    get_workorderHistoryWireUseInformationFields: state => {
        return state.workorderHistoryWireUseInformationFields
    },
    get_workorderHistoryWireUseInformationItem: state => {
        return state.workorderHistoryWireUseInformationItem
    },
}
const actions = {
    set_workorderHistoryWireUseInformationFields(context, array) {
        context.commit('SET_WORKORDERHISTORYWIREUSEINFORMATIONFIELDS', array);
    },
    set_workorderHistoryWireUseInformationItem(context, array) {
        context.commit('SET_WORKORDERHISTORYWIREUSEINFORMATIONITEM', array);
    },
    clear_workorderHistoryWireUseInformationItem(context) {
        context.commit('CLEAR_WORKORDERHISTORYWIREUSEINFORMATIONITEM');
    },
}
const mutations = {
    SET_WORKORDERHISTORYWIREUSEINFORMATIONFIELDS(state, array) {
        state.workorderHistoryWireUseInformationFields = array;
    },
    SET_WORKORDERHISTORYWIREUSEINFORMATIONITEM(state, array) {
        state.workorderHistoryWireUseInformationItem = array;
    },
    CLEAR_WORKORDERHISTORYWIREUSEINFORMATIONITEM(state) {
        state.workorderHistoryWireUseInformationItem = [];
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/workorderHistoryWireUseInformation.js